<script>
    import BasketService from '../services/api/BasketService';
    import OrderBackup from "./OrderBackup"

    export default {
        name: "OrderDataProvider",
        mixins: [OrderBackup],
        data() {
            return {
                responseProductIDs: [],
            }
        },
        created() {
            const data = this.getStorageResponseData();

            if (data) {
                this.setOrderResponseData(data);
            }
        },
        computed: {
            basketItems() {
                return this.$store.state.basket.items || [];
            },
            basketService() {
                return BasketService;
            },
            basketItemsProducts() {
                return this.basketItems.map(item => item.productId);
            },
            orderBuyerData() {
                return this.$store.state.order.buyer;
            },
            orderData() {
                return this.$store.state.order;
            },
            orderProducts() {
                return this.$store.state.order.products;
            },
            inProcessProducts() {
                return this.orderData.inProcess || [];
            },
            orderInitialProducts() {
                return this.orderData.products || null;
            },
            orderResponseData() {
                return this.$store.state.order.responseData;
            },
            orderSendData() {
                return this.inProcessProducts.filter(item => item.date && item.paymentWay && item.products.length);
            },
            orderSummaryPrice() {
                let price = 0;

                this.$store.state.order.inProcess.forEach(item => {
                    item.products.forEach(product => price += product.calculatedPrice)
                });

                return price;
            },
            dialogSellers() {
                return this.$store.state.order.dialog.sellers;
            },
            responseSuccessData() {
                return this.orderData.responseSuccessData;
            },
            responseDataGroupID() {
                return this.orderResponseData?.payment?.groupID;
            },
            responseDataUserID() {
                return this.orderResponseData?.payment?.userID;
            },
            hasLiqpayCommission() {
                const hasLiqpay = this.inProcessProducts.findIndex(item => {
                    return item.paymentWay
                        && item.paymentWay.value
                        && item.paymentWay.value.id
                        && item.paymentWay.value.id === 10;
                });
                return hasLiqpay !== -1;
            },
        },
        methods: {
            clearProductInProcess(productID) {
                this.$store.commit('orderInProcessClearProduct', productID);
            },
            getProduct(productID, sellerID) {
                if(sellerID) {
                    const seller = this.inProcessProducts.find(item => item.sellerID === sellerID);

                    if(!seller) return false;

                    return seller.products.find(item => item.id === productID);
                } else {
                    let product = null;

                    this.inProcessProducts.forEach(item => {
                        let current = item.products.find(item => item.id === productID);

                        if(current) product = current;
                    });

                    return product;
                }
            },
            getSellerName(sellerID) {
                const orderItem = this.orderProducts.find(item => item.seller.id === sellerID);

                if(!orderItem) return false;

                return orderItem.seller.companyName || `${orderItem.seller.lastName} ${orderItem.seller.firstName}`;
            },
            priceString(price) {
                return price ? parseFloat(price.toFixed(2)).toLocaleString() : false;
            },
            resetCurrentOrderData() {
                this.$store.commit('orderReset');
            },
            setStorageResponseData(data) {
                localStorage.setItem('responseData', JSON.stringify(data));
            },
            getStorageResponseData() {
                return JSON.parse(localStorage.getItem('responseData'));
            },
            clearStorageResponseData() {
                localStorage.removeItem('responseData');
            },
            resetOrderDialog() {
                this.$store.commit('orderResetDialog');
            },
            resetOrderResponse() {
                this.$store.commit('orderResetResponse');
            },
            setOrderBuyer() {
                BasketService.orderBuyerInfo()
                    .then(res => {
                        this.setStoreBuyer(res.data);
                    })
                    .catch(err => console.log(err))
            },
            setOrderProducts(products) {
                this.$store.commit('orderSetProducts', products);
            },
            setOrderProductsDelivery(data){
                this.$store.commit('orderInProcessSetDelivery', data);
            },
            setOrderDate(data) {
                this.$store.commit('orderSetDate', data);
            },
            setOrderPayment(data) {
                this.$store.commit('orderSetPayment', data);
            },
            setOrderInProcess(data) {
                this.$store.commit('orderSetInProcess', data);
            },
            setOrderResponseData(data) {
                this.$store.commit('orderSetResponseData', data);
            },
            setOrderResponseSuccessData(data) {
                this.$store.commit('orderSetResponseSuccessData', data);
            },
            setStoreBuyer(buyer) {
                this.$store.commit('orderSetBuyer', buyer);
            },
            updateProductsInProcess(data) {
                this.$store.commit('orderInProcessUpdate', data);
            },
            updateOrderConfirmDialog(data) {
                this.$store.commit('orderDialogUpdate', data);
            },
            updateOrderDate(data) {
                this.$store.commit('orderDateUpdate', data);
            },
            updateOrderPaymentWay(data) {
                this.$store.commit('orderPaymentWayUpdate', data);
            },
            updateOrderCreditPolicy(data) {
                this.$store.commit('orderCreditPolicyUpdate', data);
            },
            setProductIDsFromResponse(data = []) {
                this.responseProductIDs = data.flatMap(item => {
                    return item.products.map(product => {
                        return product.id;
                    });
                });
            },
            responseDataSuccessHandle() {
                const basketItems = this.basketItems.filter(item => this.responseProductIDs.indexOf(item.productId) < 0);
                this.$store.commit('setBasket', basketItems);

                const orderProducts = this.orderProducts.filter(item => {
                    item.data = item.data.filter(product => this.responseProductIDs.indexOf(product.id) < 0);

                    return item.data.length;
                });
                this.setOrderProducts(orderProducts);

                const inProcessProducts = this.inProcessProducts.filter(item => {
                    item.products = item.products.filter(product => this.responseProductIDs.indexOf(product.id) < 0);

                    return item.products.length;
                });
                this.setOrderInProcess(inProcessProducts);
            },
        }
    }
</script>

<style scoped>

</style>
